export const getOptionsAsPromiseArray = <T>(
  options: Promise<T[]> | T[] = []
): Promise<T[]> => {
  if (options instanceof Promise) return options;

  return Promise.all(options);
};
